import { FileText, AlertCircle } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "./DocumentCards.scss";

const InvoiceCard = ({ doc }) => {
  const [showAlert, setShowAlert] = useState(false);

  const hasFile = !!doc.invoice_file_link;
  const { t } = useTranslation();

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const handleClick = () => {
    if (!hasFile) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }
    window.open(doc.invoice_file_link, "_blank", "noopener,noreferrer");
  };

  const getDocumentTranslationKey = (type) => {
    switch (type) {
      case 'invoice-credit':
        return 'invoice-c';
      case 'invoice':
        return 'invoice';
      case 'invoice-receipt':
        return 'invoice/receipt';
      default:
        return 'invoice';
    }
  };


  return (
    <>
      <div className="document-card" onClick={handleClick}>
          <div className="document-info">
            <div
              className="document-icon"
              style={{ color: hasFile ? "#60BB46" : "#9ca3af" }}
            >
              <FileText />
            </div>

            <div>
              <div className="document-number">{doc.invoice_number}</div>
              <div className="document-date">{formatDate(doc.created_on)}</div>
              <div className="client-name">{doc.clientNameView.toLowerCase()}</div>
            </div>
        </div>

        <div className="doc-meta-amount">
          <div className="document-meta">
            {doc.type && (
              <span className="document-type">
                {t(getDocumentTranslationKey(doc.type))}
              </span>
            )}

            {doc.paid !== undefined && (
              <span className={`document-status ${doc.paid ? "paid" : "unpaid"}`}>
                {doc.paid ? t('paid') : t('not-paid')}
              </span>
            )}
          </div>
          <div>
            {doc.amountNisView && (
              <div className="document-amount amount-container" style={{ direction: 'rtl' }}>
                <p>{doc.amountNisView}</p>
                <p>{doc.currencyView}</p>
              </div>
            )}
          </div>
        </div>
      </div>







      {showAlert && (
        <div className="document-alert-wrapper">
          <div className="document-alert"
          // style={{
          //   top: `${window.scrollY + (window.innerHeight * 0.1) - 200}px` 
          // }}
          >
            <div className="document-alert-box">
              <div className="alert-icon">
                <AlertCircle />
              </div>
              <div className="alert-text">
                <h3>{t('document-not-available')}</h3>
                <p>{t('try-again-later')}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceCard;

